/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Secure setup continuation returned only to the immediate session-authenticated dashboard caller. Browser Catalogue entries return a server-owned Inspect URL; the local synthetic fixture returns a one-time handoff. Neither is part of the onboarding projection.
 */
export type PlatformMCPOnboardingSetupHandoff = {
  /**
   * Server-owned same-origin dashboard Inspect URL for the persisted browser Catalogue registration.
   */
  dashboardSetupUrl?: string | undefined;
  /**
   * One-time opaque local-fixture setup handoff.
   */
  handoff?: string | undefined;
};

/** @internal */
export const PlatformMCPOnboardingSetupHandoff$inboundSchema: z.ZodMiniType<
  PlatformMCPOnboardingSetupHandoff,
  unknown
> = z.pipe(
  z.object({
    dashboard_setup_url: z.optional(z.string()),
    handoff: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "dashboard_setup_url": "dashboardSetupUrl",
    });
  }),
);

export function platformMCPOnboardingSetupHandoffFromJSON(
  jsonString: string,
): SafeParseResult<PlatformMCPOnboardingSetupHandoff, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PlatformMCPOnboardingSetupHandoff$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PlatformMCPOnboardingSetupHandoff' from JSON`,
  );
}
